module.exports = __webpack_public_path__ + "assets/aef70bbec045f7a61651c930f330dfe2.png";